import routes from "./router/routes"
import providersBus from "./events/event-bus"
import type { Router } from "vue-router"
import type eventBusType from "@/events/event-bus"

export function providersModule({ router, eventBus }: { router: Router; eventBus: typeof eventBusType }) {
  for (const route of routes) router.addRoute("dashboard", route)

  providersBus.init(eventBus)
}
